import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Products from '../components/Products';
import Gallery from '../components/Gallery';
import Showreel from '../components/Showreel';
import Testimonials from '../components/Testimonials';
import Certifications from '../components/Certifications';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="bg-black min-h-screen">
      <Header />
      <Hero />
      <Products />
      <Gallery />
      <Showreel />
      <Testimonials />
      <Certifications />
      <About />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
